var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1629_2249)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1629_2249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 4.66667C40.8873 4.66667 51.3337 15.113 51.3337 28C51.3337 40.887 40.8873 51.3333 28.0003 51.3333C15.1133 51.3333 4.66699 40.887 4.66699 28C4.66699 15.113 15.1133 4.66667 28.0003 4.66667ZM36.2487 19.5557L24.6987 31.1057L19.752 26.1567C19.3145 25.7188 18.7209 25.4728 18.102 25.4725C17.483 25.4723 16.8893 25.718 16.4515 26.1555C16.0137 26.593 15.7676 27.1866 15.7674 27.8055C15.7671 28.4245 16.0128 29.0182 16.4503 29.456L22.8857 35.8913C23.124 36.1298 23.407 36.319 23.7185 36.448C24.03 36.5771 24.3638 36.6435 24.701 36.6435C25.0382 36.6435 25.372 36.5771 25.6835 36.448C25.995 36.319 26.278 36.1298 26.5163 35.8913L39.5503 22.8573C39.9882 22.4195 40.2341 21.8257 40.2341 21.2065C40.2341 20.5873 39.9882 19.9935 39.5503 19.5557C39.1125 19.1178 38.5187 18.8719 37.8995 18.8719C37.2803 18.8719 36.6865 19.1178 36.2487 19.5557Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1629_2249",
    x: 2.66699,
    y: 4.66667,
    width: 50.667,
    height: 50.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1629_2249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1629_2249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1629_2249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.73cf3500b1da79fce0df3e3cd84a86ee.svg";
export { ForwardRef as ReactComponent };